const BUSINESS_ORIGIN = 'business';
const GUIDES_ORIGIN = 'guides';
const ACCOUNT_ORIGIN = 'account';

export const isHostBusiness = (): boolean =>
  window.location.hostname.includes(BUSINESS_ORIGIN);

export const isHostGuides = (): boolean =>
  window.location.hostname.includes(GUIDES_ORIGIN);

export const isHostAccount = (): boolean =>
  window.location.hostname.includes(ACCOUNT_ORIGIN);
